import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { FIRMWARE } from '../../../../../store/utils/files-names';

export const getBrandsSelector = (state: AppRootState) =>
  get(state, FIRMWARE).brands;
